import { HttpClient } from '@shared/adapters/HttpClient';
import type { DeliveryRateResponse } from '../models/DeliveryRate';

export class DeliveryRateApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getOrderDeliveryRate(orderId: number): Promise<DeliveryRateResponse> {
    return this.httpClient.get<DeliveryRateResponse>(`/orders/${orderId}/delivery-rate`);
  }
}
